<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="3" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="3" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="4" cols="12">
                      <v-autocomplete
                        label="Supplier"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="supplierOptions"
                        :item-title="(item) => item.supplier_name"
                        item-value="id"
                        clearable
                        autocomplete="off"
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="3" cols="12">
                      <v-btn
                        class="bg-brand w-100"
                        type="submit"
                        ref="searchButton"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Invoice Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                        @click="goTo('/purchase/invoice-create')"
                      >
                        Create Invoice
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="invoiceList"
                  :loading="tableLoading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.invoice_date="{ item }">
                    {{ formatDate(item.invoice_date) }}
                  </template>

                  <template v-slot:item.grand_total="{ item }">
                    {{ $numberFormat(item.grand_total) }}
                  </template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="
                        item.approval_current_process &&
                        item.approval_current_process.status === 'Pending'
                      "
                      color="yellow-darken-3"
                      size="small"
                    >
                      Waiting for
                      {{
                        item.approval_current_process.approval_step_name?.name
                      }}
                    </v-chip>
                    <v-chip
                      v-else-if="
                        item.approval_current_process &&
                        item.approval_current_process.status === 'Approved'
                      "
                      color="green"
                      size="small"
                    >
                      Approved By
                      {{
                        item.approval_current_process.approval_step_name?.name
                      }}
                    </v-chip>
                    <v-chip
                      v-else-if="
                        item.approval_current_process &&
                        item.approval_current_process.status === 'Cancelled'
                      "
                      color="red"
                      size="small"
                    >
                      Cancelled By
                      {{
                        item.approval_current_process.approval_step_name?.name
                      }}
                    </v-chip>
                    <v-chip v-else color="grey" size="small">
                      {{ item.approval_status || "N/A" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="statusMap[item.status]?.color || 'grey'"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ statusMap[item.status]?.label || "Unknown" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="me-2"
                      color="primary"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath) && item.status == '0'"
                      title="Edit Invoice"
                    >
                      mdi-pencil-outline
                    </v-icon>
                    <v-icon
                      color="blue"
                      @click="viewInvoiceDetails(item)"
                      title="View Invoice Details"
                    >
                      mdi-file-document-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import formatDateView from "@/plugins/dateFormatView";
import statusMap from "@/utils/statusMap";

export default {
  data: () => ({
    panel: [0],
    panel2: [0],
    itemsPerPage: 10,
    search: "",
    statusMap,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "6%", sortable: false },
      { title: "Invoice Code", align: "left", key: "code", sortable: true },
      {
        title: "Supplier",
        align: "left",
        key: "supplier.supplier_name",
        sortable: true,
      },
      {
        title: "Invoice Date",
        align: "center",
        key: "invoice_date",
        sortable: true,
      },
      {
        title: "Grand Total",
        align: "end",
        key: "grand_total",
        sortable: true,
      },
      {
        title: "Approval Status",
        align: "center",
        key: "approval_status_display",
        sortable: false,
      },
      {
        title: "Status",
        align: "center",
        key: "status",
        sortable: true,
      },
      {
        title: "Actions",
        align: "center",
        key: "actions",
        sortable: false,
        width: "10%",
      },
    ],
  }),
  created() {
    if (!this.$store.getters.getSupplierList.length) {
      this.$store.dispatch("getSupplierList").catch(() => {});
    }
  },
  computed: {
    invoiceList() {
      return this.$store.getters.getPurInvoiceList || [];
    },
    supplierOptions() {
      return this.$store.getters.getSupplierList || [];
    },
  },
  setup() {
    const store = useStore();
    const tableLoading = ref(false);

    const { handleSubmit } = useForm({
      validationSchema: yup.object({}),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const supplier_id = useField("supplier_id");

    const submit = handleSubmit((values) => {
      tableLoading.value = true;
      values.from_date = from_date.value.value ? formattedDate(from_date.value.value) : null;
      values.to_date = to_date.value.value ? formattedDate(to_date.value.value) : null;
      values.supplier_id = supplier_id.value.value || null;

      store
        .dispatch("getPurInvoiceList", values)
        .then(() => {
          tableLoading.value = false;
        })
        .catch((error) => {
          tableLoading.value = false;
          toast.error(
            error?.response?.data?.message || "Failed to load invoices"
          );
        });
    });

    return {
      submit,
      from_date,
      to_date,
      supplier_id,
      tableLoading,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return formatDateView(date);
    },
    goTo(path) {
      this.$router.push({ path }).catch(() => {});
    },
    editItem(item) {
      this.$router.push({
        name: "purchase-invoice-create",
        query: { id: item.id },
      });
    },
    viewInvoiceDetails(item) {
      this.$router.push({
        name: "view-purchase-invoice",
        params: { id: item.id },
      });
    },
    exportToPDF() {
      let serial = 1;
      const columns = [
        "#SL",
        "Invoice Code",
        "Supplier",
        "Invoice Date",
        "Grand Total",
        "Status",
      ];
      const rows = this.invoiceList.map((item) => [
        serial++,
        item.code,
        item.supplier?.supplier_name || "",
        this.formatDate(item.invoice_date),
        this.$numberFormat(item.grand_total),
        this.statusMap[item.status]?.label || "Unknown",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Purchase Invoice Records",
        "purchase_invoice_record_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      const data = [
        [
          "#SL",
          "Invoice Code",
          "Supplier",
          "Invoice Date",
          "Grand Total",
          "Status",
        ],
      ];
      let serial = 1;
      this.invoiceList.forEach((item) => {
        data.push([
          serial++,
          item.code,
          item.supplier?.supplier_name || "",
          this.formatDate(item.invoice_date),
          this.$numberFormat(item.grand_total),
          this.statusMap[item.status]?.label || "Unknown",
        ]);
      });
      this.$exportTableToExcel(
        data,
        "purchase_invoice_record_" + this.$fileDate()
      );
    },
    exportToCSV() {
      const data = [
        [
          "#SL",
          "Invoice Code",
          "Supplier",
          "Invoice Date",
          "Grand Total",
          "Status",
        ],
      ];
      let serial = 1;
      this.invoiceList.forEach((item) => {
        data.push([
          serial++,
          item.code,
          item.supplier?.supplier_name || "",
          this.formatDate(item.invoice_date),
          this.$numberFormat(item.grand_total),
          this.statusMap[item.status]?.label || "Unknown",
        ]);
      });
      this.$exportTableToCSV(
        data,
        "purchase_invoice_record_" + this.$fileDate()
      );
    },
  },
  mounted() {
    this.panel2 = [0];
    // Set default dates to today, but allow clearing to see all invoices
    this.from_date.value.value = new Date();
    this.to_date.value.value = new Date();
    this.$nextTick(() => {
      // Auto-search on mount to load today's invoices
      if (this.$refs.searchButton) {
        this.$refs.searchButton.$el.click();
      }
    });
  },
};
</script>

